export const auth = {
    brand: {
        tagline: "অনলাইন ও অফলাইন — আপনার দোকান চলুক এক জায়গা থেকে।",
        points: {
            offline: "ইন্টারনেট ছাড়াও বিক্রি চলে, ফিরে এলে নিজে থেকেই সিঙ্ক হয়।",
            stock: "ওয়েবসাইট, ফোন অর্ডার আর সব শাখায় একটাই স্টক।",
            channels: "অর্ডার, কুরিয়ার, কাস্টমার ও হিসাব — সব এক সিস্টেমে।",
        },
        footer: "বাংলাদেশের ব্যবসার জন্য তৈরি।",
    },
    signIn: {
        title: "সাইন ইন",
        identifier: "ইমেইল বা মোবাইল নম্বর",
        password: "পাসওয়ার্ড",
        submit: "সাইন ইন করুন",
        withOtp: "এসএমএস কোড দিয়ে সাইন ইন করুন",
        forgot: "পাসওয়ার্ড ভুলে গেছেন?",
    },
    otp: {
        title: "এসএমএস কোড দিয়ে সাইন ইন",
        phone: "মোবাইল নম্বর",
        send: "কোড পাঠান",
        code: "৬ সংখ্যার কোড",
        verify: "যাচাই করে সাইন ইন করুন",
        sent: "এই নম্বরে কোনো অ্যাকাউন্ট থাকলে আমরা একটি কোড পাঠিয়েছি।",
        resend: "নতুন কোড পাঠান",
        withPassword: "পাসওয়ার্ড দিয়ে সাইন ইন করুন",
    },
    totp: {
        title: "দুই ধাপের যাচাই",
        body: "অথেনটিকেটর অ্যাপের ৬ সংখ্যার কোড অথবা একটি রিকভারি কোড লিখুন।",
        code: "কোড",
        submit: "যাচাই করুন",
    },
    forgot: {
        title: "পাসওয়ার্ড রিসেট করুন",
        body: "আপনার ইমেইল বা মোবাইল নম্বর লিখুন। আমরা একটি রিসেট লিংক বা কোড পাঠাব।",
        identifier: "ইমেইল বা মোবাইল নম্বর",
        submit: "পাঠান",
        sent: "অ্যাকাউন্ট থাকলে আমরা সেখানে নির্দেশনা পাঠিয়েছি।",
    },
    reset: {
        title: "নতুন পাসওয়ার্ড দিন",
        phone: "মোবাইল নম্বর",
        code: "৬ সংখ্যার কোড",
        password: "নতুন পাসওয়ার্ড",
        confirm: "নতুন পাসওয়ার্ড আবার লিখুন",
        mismatch: "পাসওয়ার্ড দুটি মেলেনি।",
        submit: "নতুন পাসওয়ার্ড সেট করুন",
        done: "আপনার পাসওয়ার্ড পরিবর্তন হয়েছে। অনুগ্রহ করে সাইন ইন করুন।",
    },
    signedOut: "আপনি সাইন আউট হয়েছেন।",
    signUp: {
        title: "আপনার ব্যবসার অ্যাকাউন্ট খুলুন",
        intro: "বিনা খরচে ট্রায়াল, কোনো পেমেন্ট লাগবে না। দোকান আর অনলাইন অর্ডার এক জায়গায়।",
        phone: "আপনার মোবাইল নম্বর",
        sendCode: "কোড পাঠান",
        codeSent: "{{phone}} নম্বরে ৬ সংখ্যার একটি কোড পাঠানো হয়েছে।",
        changePhone: "অন্য নম্বর দিন",
        emailFirst: "আপনার ই-মেইল",
        codeSentEmail: "{{email}}-এ ৬ সংখ্যার একটি কোড পাঠানো হয়েছে। ইনবক্স আর স্প্যাম ফোল্ডার দেখুন।",
        changeEmail: "অন্য ই-মেইল দিন",
        resend: "নতুন কোড পাঠান",
        code: "৬ সংখ্যার কোড",
        businessName: "ব্যবসার নাম",
        businessType: "কীভাবে বিক্রি করেন?",
        businessTypes: { online: "শুধু অনলাইনে", offline: "শুধু দোকানে", both: "অনলাইনে ও দোকানে" },
        plannedBranches: "শাখার সংখ্যা",
        ownerName: "আপনার নাম",
        email: "ই-মেইল",
        password: "পাসওয়ার্ড",
        passwordHint: "কমপক্ষে ৮ অক্ষর।",
        accept: "আমি সেবার শর্তাবলি ও গোপনীয়তা নীতি মেনে নিচ্ছি।",
        read: "পড়ুন:",
        mustAccept: "চালিয়ে যেতে সেবার শর্তাবলি ও গোপনীয়তা নীতি মেনে নিন।",
        submit: "আমার ব্যবসা চালু করুন",
        haveAccount: "আগে থেকেই অ্যাকাউন্ট আছে? সাইন ইন করুন",
        noAccount: "নতুন? ব্যবসার অ্যাকাউন্ট খুলুন",
        unavailable: "এখানে নতুন ব্যবসার অ্যাকাউন্ট খোলা যায় না।",
    },
    legal: {
        title: "আমাদের শর্তাবলি হালনাগাদ হয়েছে",
        body: "Sobthik ব্যবহার চালিয়ে যেতে নতুন সংস্করণটি পড়ে মেনে নিন।",
        accept: "মেনে নিয়ে চালিয়ে যান",
    },
};
//# sourceMappingURL=auth.js.map